import { Injectable, Inject, OnDestroy } from '@angular/core';

import * as webstomp from 'webstomp-client';
import { connectToSocket, SOCKET_URL, getComponentOnDestroy$ } from 'projects/core/src/public-api';
import { AppStateStore } from 'projects/desktop/src/app/data/app-state.store';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';

import { Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class WsService {
  socket: webstomp.Client;

  constructor(
    protected appStateStore: AppStateStore,
    protected appStateQuery: AppStateQuery,
    @Inject(SOCKET_URL) protected socketUrl: string
  ) {
  }

  connectToSocket() {
    this.socket = this.socket || connectToSocket(`${this.socketUrl}`, this.onSocketConnected.bind(this), {}, true);

    return this.socket;
  }

  onSocketConnected() {
    this.appStateStore.update({
      wsSocketReady: true
    })
  }

  listenUntil<T>(topic: string, until: Observable<any>): Observable<T> {
    return Observable.create((observer: Subject<T>) => {
      this.appStateQuery
        .wsSocketReady$
        .pipe(
          filter(ready => ready)
        )
        .subscribe(() => {
          // console.log(`subscribe to topic ${topic}`)
          const socketSubscription = this.socket
            .subscribe(topic.toLowerCase(), (message: any) => {
              // console.log(`emit ws update`);
              // console.log(JSON.parse(message.body) as T);
              observer.next(JSON.parse(message.body) as T);
            })

          until.subscribe(() => {
            socketSubscription.unsubscribe();
            observer.complete();
          })
        })
    });
  }

  listenUntilDestroyed<T>(topic: string, cmp: OnDestroy): Observable<T> {
    return this.listenUntil(topic, getComponentOnDestroy$(cmp))
  }
}
